<template>
  <div class="header">
    <div class="header_t1">每人纪</div>
    <div :class="head == 0 ? 'header_t2' : 'header_t3'" @click="navto(0)">首页</div>
    <div :class="head == 1 ? 'header_t2' : 'header_t3'" @click="navto(1)">人才库</div>
    <div :class="head == 2 ? 'header_t2' : 'header_t3'" @click="navto(2)">作品动态</div>
    <div :class="head == 3 ? 'header_t2' : 'header_t3'" @click="navto(3)">关于我们</div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  data() {
    return {
      head: 0
    }
  },
  props: ['selectIndex'],
  created() {
    this.head = this.selectIndex
  },
  methods: {
    navto(index) {
      if (this.head == index) {
        return
      }
      if (index == 0) {
        this.$router.push('/index/index')
      }
      else if (index == 1) {
        this.$router.push('/people/index')
      }
      else if (index == 2) {
        this.$router.push('/notice/index')
      }
      else if (index == 3) {
        this.$router.push('/about/index')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  // width: 100%;
  height: 68px;
  background-image: linear-gradient(134deg, #3EA6FF 0%, #C042FF 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25%;
}

.header_t1 {
  font-family: PingFangSC-Semibold;
  font-size: 32px;
  color: #FFFFFF;
  font-weight: 600;
}

.header_t2 {
  font-family: PingFangSC-Semibold;
  font-size: 24px;
  color: #FFFFFF;
  font-weight: 600;
}

.header_t3 {
  font-family: PingFangSC-Regular;
  font-size: 20px;
  color: #DCDDDD;
  font-weight: 400;
}

/* 1200-1600 */
@media screen and (max-width:1600px) {}

/* 992-1200 */
@media screen and (max-width: 1200px) {
  .header {
    padding: 0 15%;
  }
}

/* 750-992 */
@media screen and (max-width:992px) {
  .header {
    padding: 0 5%;
  }

  .header_t1 {
    font-size: 20px;
  }

  .header_t2 {
    font-size: 18px;
  }

  .header_t3 {
    font-size: 16px;
  }
}

/* 375-750 */
@media screen and (max-width:750px) {
  .header {
    padding: 0 5%;
  }

  .header_t1 {
    font-size: 20px;
  }

  .header_t2 {
    font-size: 18px;
  }

  .header_t3 {
    font-size: 16px;
  }
}
</style>